import { createStyles, Theme } from '@material-ui/core';

const styles = ({ colors, spacing, typography }: Theme) => createStyles({
  textError: {
    ...typography.textTiny,
    color: colors.inputs.errorMessage.text,
    marginLeft: spacing(0.5),
    '&&': {
      marginBottom: 0,
    },
  },
  errorBox: {
    display: 'flex',
    marginTop: spacing(1),
    padding: `${spacing(0.5)}px ${spacing(1)}px`,
    alignItems: 'center',
    '& svg': {
      fill: colors.inputs.errorMessage.icon,
      display: 'block',
      width: spacing(3),
      height: spacing(3),
    },
  },
});

export default styles;
